/**
 * Language codes and culture names, mirrored from Procuidado.Data/Constants/LanguageCodes.cs and
 * CultureNames.cs and pinned against them by MagicStringConventionTests.
 */
export const LanguageCodes = Object.freeze({
  Portuguese: "pt",
  English: "en",
  Spanish: "es",
  French: "fr",
  Default: "pt",
});

export const CultureNames = Object.freeze({
  Portugal: "pt-PT",
  UnitedKingdom: "en-GB",
});
